import { Stack } from '@mui/material';
import { Caption, Section } from '@telegram-apps/telegram-ui';
import { AnimatePresence } from 'framer-motion';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { RitualType } from '../../client/generated/graphql';
import { ListQuest } from '../../client/types';
import { getRitualConfig } from '../../helpers/ritual';
import { DailyProgressExtended } from '../../hooks/useDailyProgress';
import { ritualEditPath } from '../../navigation/paths';
import { RitualCard } from '../ritual/RitualCard';

interface RitualQuestSectionProps {
    quest: ListQuest | null;
    sectionKey: string;
    dailyProgressData?: DailyProgressExtended | null;
    onItemClick: (q: ListQuest) => void;
}

export const RitualQuestSection: FC<RitualQuestSectionProps> = ({
    quest,
    sectionKey,
    dailyProgressData,
    onItemClick,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (!quest) return null;

    const ritualType = quest.ritualType as RitualType;
    const config = getRitualConfig(t)[ritualType];
    
    const subTasks = quest.subTasks ?? [];
    const completedCount = subTasks.filter(t => t.done).length;
    const totalCount = subTasks.length;
    
    const sectionProgress = dailyProgressData?.progressMap[sectionKey];
    const isCompleted = sectionProgress?.done === sectionProgress?.total;

    return (
        <Section
            header={
                <Section.Header
                    style={{
                        paddingTop: isCompleted ? '5px' : undefined,
                        paddingBottom: isCompleted ? '0px' : undefined,
                    }}
                >
                    <Stack direction="row" justifyContent="space-between">
                        <Caption>{config.title}</Caption>
                        <Stack direction="row">
                            <Caption>
                                {completedCount} / {totalCount}
                            </Caption>
                        </Stack>
                    </Stack>
                </Section.Header>
            }
            style={{ marginBottom: isCompleted ? '0px' : undefined }}
        >
            <AnimatePresence>
                <RitualCard
                    key={quest.id}
                    quest={quest}
                    onClick={() => navigate(ritualEditPath.replace(':ritualType', ritualType))}
                    onActionClick={() => onItemClick(quest)}
                />
            </AnimatePresence>
        </Section>
    );
};
